<div *ngIf="errorMessages !== null">
  <div *ngFor="let errorMessage of errorMessages">
    <div class="error-messages" [innerHTML]="errorMessage"></div>
  </div>
</div>
